module.exports = __webpack_public_path__ + "img/HR.63b2b01d.svg";